const NEW_RELIC_METHODS = [
  'addPageAction',
  'addToTrace',
  'finished',
  'noticeError',
  'setCustomAttribute',
  'setErrorHandler',
  'setPageViewName',
];

function stubCreator(methods) {
  return function createStub() {
    return _.reduce(methods, (stub, method) => {
      stub[method] = _.noop;
      return stub;
    }, {});
  };
}

export const createStub = stubCreator(NEW_RELIC_METHODS);



// WEBPACK FOOTER //
// ./src/shared/analytics/new-relic/new-relic-stub.js